<tui-root>
  <router-outlet></router-outlet>
  <ng-container ngProjectAs="tuiOverContent">
  </ng-container>
  <ng-container ngProjectAs="tuiOverDialogs">
  </ng-container>
  <ng-container ngProjectAs="tuiOverAlerts">
  </ng-container>
  <ng-container ngProjectAs="tuiOverPortals">
  </ng-container>
  <ng-container ngProjectAs="tuiOverHints">
  </ng-container>
</tui-root>